"use client";

import React from "react";
import { ArrowRight, CircleCheck, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TurnYourSmartphoneIntoAMoneyMakingMachine() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="185168" id="break-free-from-the-burden" className="relative w-full min-h-[90vh] flex items-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 bg-primary z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#131d2b] via-[#1a2e44] to-[#0a121c] opacity-90" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(107,45,130,0.15),_transparent_60%)] animate-pulse" style={{
        animationDuration: '8s'
      }} />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 py-20 lg:py-32">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-12">
          
          {}
          <div ref={leftRef} className={`w-full lg:w-[60%] flex flex-col gap-8 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary/20 border border-secondary/30 text-secondary-foreground text-sm font-medium backdrop-blur-md w-fit">
                <Sparkles className="size-4 text-secondary-foreground" />
                Trusted Timeshare Exit Solutions
              </div>
              
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-default font-extrabold tracking-tight text-white leading-[1.1]">
                Break Free From the <br className="hidden sm:block" />
                <span className="bg-gradient-to-r from-[#fdfaf3] via-[#f5f1e6] to-[#ece5d3] bg-clip-text text-transparent drop-shadow-sm mt-2 block">
                  Timeshare Burden
                </span>
              </h1>
            </div>

            <p className="text-lg sm:text-xl lg:text-2xl text-slate-300 leading-relaxed max-w-2xl font-sans font-light">
              Help for owners facing <strong className="text-white font-semibold">fees, mortgages, or misrepresentation.</strong> Regain your financial freedom with professional guidance.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 pt-4">
              <Button asChild size="lg" className="h-14 px-8 text-lg bg-secondary hover:bg-secondary/90 text-secondary-foreground font-default font-bold border-none shadow-xl transition-all duration-300 hover:scale-105 hover:shadow-secondary/40 rounded-lg">
                <Link to="https://quitmytimeshare.com/eligibility-check/">
                  Check Eligibility <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              
              <div className="flex items-center gap-3 text-sm text-slate-300">
                <CircleCheck className="size-5 text-secondary-foreground" />
                <span className="font-sans font-medium tracking-wide uppercase">Expert Legal Guidance</span>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`w-full lg:w-[40%] relative transition-all duration-1000 delay-300 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative w-full aspect-[4/5] max-w-md mx-auto lg:ml-auto">
              {}
              <div className="absolute inset-0 bg-secondary blur-[80px] opacity-20 rounded-full animate-pulse" style={{
              animationDuration: '6s'
            }} />
              
              {}
              <div className="relative h-full w-full rounded-lg overflow-hidden border border-white/20 shadow-2xl animate-[bounce_6s_ease-in-out_infinite] bg-white backdrop-blur-sm group">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627436/img/professional_smartphone_home_office.png" alt="Professional working from home holding a smartphone" className="w-full h-full object-cover opacity-90 transition-all duration-700" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-tr from-primary/40 via-transparent to-white/10 pointer-events-none" />
              </div>

              {}
              <div className="absolute -bottom-8 -left-8 bg-white backdrop-blur-xl border border-border p-5 rounded-lg shadow-2xl flex items-center gap-4 animate-[bounce_5s_ease-in-out_infinite_reverse]">
                <div className="bg-secondary/10 p-3 rounded-full border border-secondary/20">
                  <CircleCheck className="size-6 text-secondary" />
                </div>
                <div>
                  <p className="text-primary font-default font-extrabold text-xl">100%</p>
                  <p className="text-muted-foreground text-xs font-sans font-medium uppercase tracking-wider">Privacy Guaranteed</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}